<!--阅读拓展馆-->
<template>
    <div class="read_nav_content">
        <!-- 阅读拓展首页 -->
        <div class="read-museum-container" v-show="showMode==='homePage'">
            <div class="museum-title-container">
                <div class="l-museum-title-container">
                    <div class="l-t-museum-title-container">恒岳·阅读拓展馆</div>
                    <div class="l-b-museum-title-container">多元阅读资源养成终身习惯</div>
                </div>
                <div class="r-museum-title-container">
                    <div v-show="this.isShowBack" class="back-btn-container" @click="backMuseum" >⇦返回</div>
                </div>
            </div>
            <div class="museum-item-container">
                <div class="museum-item-line-container">
                    <div class="museum-item-top-container">
                        <div class="museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">名著导读</div>
                                <div class="museum-item-20 mf2">教育部1-9年级分学段推荐书目</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewReadModel('read')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">
                        <div class="museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">美育浸润</div>
                                <div class="museum-item-20 mf2">十四个系列视频资源</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewReadModel('bymy')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">
                        <div class="museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">博雅大语文</div>
                                <div class="museum-item-20 mf2">1-6年级语文逐课拓展阅读资源</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewReadModel('language')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="museum-item-bottom-container">
                    <div class="museum-item-bottom-outside">
                        <div class="museum-item-bottom-inside">
                            <div class="museum-item-bottom-inside-l">
                                <div class="museum-item-60 mf1">恒岳读书会</div>
                                <div class="museum-item-40 mf2">1-12月主题阅读活动</div>
                            </div>
                            <div class="museum-item-bottom-inside-r dis-align">
                                <div class="inside-r-btn" @click="viewReadModel('bookClub')">查看线下活动</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 名著导读 -->
        <div class="read_nav_content" v-show="showMode==='model-read'">
            <reading-guide @back-read-museum="backReadMuseum" :mark-info="markInfo"/>
        </div>

        <!-- 美育浸润 -->
        <div class="read_nav_content" v-show="showMode==='model-bymy'">
            <beauty-edu @back-read-museum="backReadMuseum" :mark-info="markInfo"/>
        </div>

        <!-- 博雅大语文 -->
        <div class="read_nav_content" v-show="showMode==='model-language'">
            <boyaa-chinese @back-read-museum="backReadMuseum" :mark-info="markInfo"/>
        </div>

        <!-- 恒岳读书会 -->
        <div class="read_nav_content" v-show="showMode==='model-bookClub'">
            <read-event-club :museum-id="this.museumId"
                               :mark-info="this.markInfo"
                               @back-read-museum="backReadMuseum"/>
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import readingGuide from "@/components/newMuseum/read/readingGuide.vue";
import boyaaChinese from "@/components/newMuseum/read/boyaaChinese.vue";
import beautyEdu from "@/components/newMuseum/read/beautyEdu.vue";
import readEventClub from "@/components/museumEvent/readEventClub.vue";

export default {
    name: "readExtensionMuseum",
    components: {readEventClub, readingGuide,boyaaChinese,beautyEdu},
    data() {
        return {
            showMode:'homePage',
            baseMode:'model-',
            serviceUrl,
            markInfo:'',
            museumId:'',
        }
    },
    computed: {},
    props:{
        isShowBack:{
            type: Boolean,
            default:true
        },
    },
    watch: {
        isShowBack(newValue,oldValue){
        },
    },
    created() {
    },
    mounted(){},
    methods: {
        /*返回五馆首页*/
        backMuseum(){
            this.$emit('child-back-museum', "page");
        },
        /*查看阅读馆模块*/
        viewReadModel(val){
            this.markInfo = new Date();
            this.museumId = '1';
            this.showMode =  this.baseMode+val;
        },
        /*从子模块阅读馆*/
        backReadMuseum(val){
            this.showMode = "homePage";
        }
    }
}
</script>
<style scoped>
.read-museum-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.museum-title-container{
    width: 100%;
    height: 70px;
    display: flex;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #0d55a4;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}

.museum-item-container{
    width: 100%;
    height: calc(100% - 70px);
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.museum-item-line-container{
    width: 100%;
    height: 45%;
    display: flex;
    gap: 20px;
}
.museum-item-top-container{
    width: 33.3%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
}
.museum-item-top{
    width: 100%;
    height: 60%;
    border-left: 5px solid #0d55a4;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    //box-shadow: var(--el-box-shadow-light);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.museum-item-content{
    width: 90%;
    height: 80%;
}
.museum-item-40{
    width: 100%;
    height: 40%;
}
.museum-item-60{
    width: 100%;
    height: 60%;
}
.mf1{
    color: #0d55a4;
    //font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: clamp(16px, 12cqh, 18px);
}
.mf2{
    color: #9a9a9a;
    font-size: 14px;
}
.museum-item-20{
    width: 100%;
    height: 20%;
}
.resource-btn{
    width: 100%;
    height: 70%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}
.dis-align{
    display: flex;
    justify-items: center;
    align-items: center;
}

.museum-item-bottom-container{
    width: 100%;
    height: 45%;
}
.museum-item-bottom-outside{
    width: 100%;
    height: 50%;
    border: 3px solid #0d55a4;
    display: flex;
    align-items: center;
    justify-content: center;
}
.museum-item-bottom-inside{
    width: 99%;
    height: 92%;
    border: 1px solid #e99d42;
    padding: 10px 20px 10px 20px;
    box-sizing: border-box;
    display: flex;
}

.museum-item-bottom-inside-l{
    width: calc(100% - 120px);
    height: 100%;
}
.museum-item-bottom-inside-r{
    width: 120px;
    height: 100%;
}
.inside-r-btn{
    width: 100%;
    height: 38%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}
.read_nav_content{
    width: 100%;
    height: auto;
}
</style>